/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2020 Open Assessment Technologies SA ;
 */

/**
 * Get the configured asset manager factory
 *
 */
import assetManagerFactory from '@oat-sa-private/tao-item-runner-qtinui/src/runner/asset/assetManager.js';

//keep reference per test id
const assetManagers = {};

/**
 * Gives access to a configured assetManagerFactory
 * @param {string} testId - a unique identifier for the test instance
 * @param {Object} [options] - options for the asset manager
 * @param {string} [options.staticUrl] - URL where static bundles are
 * @returns {assetManagerFactory}
 */
export default function getAssetManager(testId, options = {}) {
    let assetManager;

    if (typeof assetManagers[testId] !== 'undefined') {
        assetManager = assetManagers[testId];
    } else {
        assetManager = assetManagerFactory({ baseUrl: '', workerBase: options.staticUrl || '' });
        assetManagers[testId] = assetManager;
    }

    return assetManager;
}
